import { defineStore } from "pinia";
import { fetchPermissions, fetchRoles, fetchAdmins } from "@/api/admin";

export const adminStore = defineStore("admin", {
    state: () => ({
        roles: [],
        permissions: [],
        singleRole: null,
        admins: []
    }),

    actions: {
        async loadAdmins() {
            try {
                const res = await fetchAdmins()
                const admins = res.data.data
                this.admins = Array.isArray(admins)
                    ? admins
                    : []
                return true
            } catch (error) {
                this.admins = []

                if (error.response?.status === 403) {
                    return false
                }

                throw error
            }
    },
    async loadRoles() {
        const res = await fetchRoles()
        const roles = res.data.data
        this.roles = Array.isArray(roles)
            ? roles
            : []
    },
    async loadPermissions() {
        const res = await fetchPermissions()
        const permissions = res.data.data
        this.permissions = Array.isArray(permissions)
            ? permissions
            : []
    }
    // async loadSingleRole(id) {
    //     try {
    //         const res = await fetchSingleRole(id)
    //         this.singleRole = res.data.data
    //     } catch (error) {
    //         console.error("Failed to load role:", error)
    //     }
    // },
}
})

